<template>
	<div class="app-container">
		<!--    <el-row type="flex" class="row-bg" justify="space-around">
      <el-col :span="8" class="flex">
        <span>省份：</span>
        <el-select v-model="search.sfen" placeholder="请选择" clearable style="width:100%" @change="getTblCity">
          <el-option v-for="item in provinceList" :key="item.sfid" :label="item.sfen" :value="item.sfen"
                     style="width:100%">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="8" class="flex">
        <span>城市：</span>
        <el-select v-model="search.cshi" placeholder="请选择" clearable style="width:100%" :disabled="!search.sfen"
                   @change="getTblCounty">
          <el-option v-for="item in cityList" :key="item.ciid" :label="item.city" :value="item.city" style="width:100%">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="8" class="flex">
        <span>区县：</span>
        <el-select v-model="search.county" placeholder="请选择" clearable style="width:100%" :disabled="!search.cshi">
          <el-option v-for="item in countyList" :key="item.ciid" :label="item.county" :value="item.county"
                     style="width:100%">
          </el-option>
        </el-select>
      </el-col>
    </el-row>-->
		<el-row type="flex" class="row-bg">
			<el-col :span="8" class="flex">
				<span>
					回收大类：
				</span>
				<el-select
					v-model="search.spid"
					placeholder="请选择"
					clearable
					style="width:100%"
					@change="dlChangeFun"
				>
					<el-option
						v-for="item in dlList"
						:key="item.value"
						:label="item.spmc"
						:value="item.spid"
						style="width:100%"
					>
					</el-option>
				</el-select>
			</el-col>
			<el-col :span="8" class="flex">
				<span>回收小类：</span>
				<el-select
					:disabled="!search.spid"
					v-model="search.xlid"
					placeholder="请选择"
					clearable
					style="width:100%"
				>
					<el-option
						v-for="item in xlList"
						:key="item.xlid"
						:label="item.xlmc"
						:value="item.xlid"
						style="width:100%"
					>
					</el-option>
				</el-select>
			</el-col>
			<el-col :span="8" class="flex">
				<span style="flex-shrink: 0">
					合作方名称：
				</span>
				<el-input v-model="search.partnerName" placeholder="请输入合作方名称"></el-input>
			</el-col>
			<el-col :span="8" class="flex">
				<el-button type="primary" size="medium" @click="searchBtnFun">查询</el-button>
				<el-button size="medium" @click="resetForm()">重置</el-button>
			</el-col>
		</el-row>
		<div class="m-b-10">
			<el-button type="primary" size="medium" @click="addArea">+&nbsp;创建新区域</el-button>
			<el-button
				:type="allSelectedIds.length ? 'primary' : 'info'"
				:disabled="allSelectedIds.length ? false : true"
				size="medium"
				@click="batchDelete"
				>批量删除
			</el-button>
		</div>
		<el-table
			:data="list"
			@selection-change="handleSelectionChange"
			:reserve-selection="true"
			height="60vh"
		>
			<el-table-column type="selection" min-width="50" align="center"> </el-table-column>
			<el-table-column label="地区编号" min-width="120" align="center">
				<template slot-scope="scope">{{ scope.row.regionId }}</template>
			</el-table-column>
			<el-table-column label="回收大类" min-width="100" align="center">
				<template slot-scope="scope">{{ scope.row.spmc }}</template>
			</el-table-column>
			<el-table-column
				label="回收小类"
				prop="xlmc"
				min-width="100"
				align="center"
			></el-table-column>
			<el-table-column label="回收价格" min-width="100" align="center">
				<template slot-scope="scope">{{ scope.row.recyclingPrice }}</template>
			</el-table-column>
			<el-table-column label="生效范围" min-width="100" align="userType">
				<template slot-scope="scope">{{ scope.row.userType === 1 ? '用户订单' : '批量订单' }}</template>
			</el-table-column>
			<el-table-column label="合作方名称" min-width="100" align="center">
				<template slot-scope="scope">{{ scope.row.partnerName }}</template>
			</el-table-column>
			<el-table-column show-overflow-tooltip label="区域范围" min-width="100" align="center">
				<template slot-scope="scope">{{ scope.row.regionName }}</template>
			</el-table-column>
			<el-table-column label="操作" fixed="right" width="150" align="center">
				<template slot-scope="scope">
					<el-button type="text" @click="goEdit(scope.row)">编辑</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="pagination-container">
			<el-pagination
				background
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				layout="total, sizes,prev, pager, next,jumper"
				:current-page.sync="search.pageNum"
				:page-size="search.pageSize"
				:page-sizes="[10, 20]"
				:total="total"
			>
			</el-pagination>
		</div>
		<edit-area
			v-if="dialogFormVisible"
			:visible.sync="dialogFormVisible"
			:edit-id="editId"
			@onClose="getList"
		></edit-area>
	</div>
</template>
<script>
import editArea from '@/views/recoveryManagement/component/editArea.vue'
export default {
	name: 'areaManagement',
	components: { editArea },
	data() {
		return {
			list: [],
			search: {
				spid: '',
				xlid:'',
				partnerName: '',
				areaName: '',
				sfen: '',
				cshi: '',
				county: '',
				pageSize: 10,
				pageNum: 1,
			},
			// 选中过的页码
			selectedPageNums: [],
			// 选中也所有的数据
			selectedAllData: [],
			// 是否全选中
			allChecked: false,
			allSelectedIds: [],
			unSelectedIds: [], // 所有未选中的id
			total: 0,
			dialogFormVisible: false,
			editId: '',
			provinceList: [],
			cityList: [],
			countyList: [],
			dlList: [], //大类
			xlList: [], //小类
		}
	},
	created() {
		this.getList()
	},
	methods: {
		searchBtnFun() {
			this.search.pageNum = 1
			this.getList()
		},
		handleSelectionChange(rows) {
			const selectedIds = rows.map(item => item.regionId)
			const unSelectedIds = this.list
				.map(item => item.regionId)
				.filter(item => !selectedIds.includes(item))
			// // 获的所有选中的项
			this.allSelectedIds = this.allSelectedIds.filter(item => !unSelectedIds.includes(item))
			// // //获得未选中的项
			this.unSelectedIds = unSelectedIds
			// // 数组去重
			this.allSelectedIds = [...new Set([...this.allSelectedIds, ...selectedIds])]
			console.log(this.allSelectedIds, 'this.allSelectedIds')
		},
		getList() {
			this.list = []
			this.HttpService.post(
				'/autoapp-default-server-recovery/api/area-management/list',
				this.search
			).then(res => {
				if (res.statusCode === 200) this.total = res.data.total
				if (res.data.length === 0) {
					this.$dialog({
						title: '温馨提示',
						content: '未查询到结果!',
						footBtn: false,
						width: '20%',
						dialogType: 'sighicon',
					})
				} else {
					this.arr = []
					this.list = res.data.records
				}
			})
		},
		handleSizeChange(val) {
			this.search.pageNum = 1
			this.search.pageSize = val
			this.getList()
		},
		handleCurrentChange() {
			this.getList()
		},
		batchDelete() {
			this.$dialog({
				title: '温馨提示',
				content: '是否要删除，删除后不可以恢复！',
				cancel_buttton: '否',
				ok_buttton: '是',
				width: '400px',
				footBtn: 'card',
				dialogType: 'delete',
				onOk: () => {
					this.HttpService.delete(
						`/autoapp-default-server-recovery/api/area-management/delete?idList=${this.allSelectedIds}`
					).then(res => {
						if (res.statusCode === 200) this.$message.success('删除成功')
						this.getList()
						this.allSelectedIds = []
						this.unSelectedIds = []
					})
				},
				onCancel: () => {
					console.log('cancel')
				},
			})
		},
		addArea() {
			this.dialogFormVisible = true
			this.editId = ''
		},
		goEdit(data) {
			this.editId = data.regionId
			this.dialogFormVisible = true
		},
		closeDialog() {
			this.dialogFormVisible = false
		},
		resetForm(formName) {
			this.search = this.$options.data().search
		},
		getTblCity() {
			this.search.cshi = ''
			this.search.county = ''
			return this.HttpService.get(
				`/autoapp-default-server-recovery/api/tbl-city/getTblCity?sfen=${this.search.sfen}`
			).then(res => {
				if (res.statusCode === 200) {
					this.cityList = res.data
				}
			})
		},
		getTblProvince() {
			this.search.cshi = ''
			this.search.county = ''
			return this.HttpService.get(
				`/autoapp-default-server-recovery/api/tbl-province/getTblProvince`
			).then(res => {
				if (res.statusCode === 200) {
					this.provinceList = res.data
				}
			})
		},
		getTblCounty() {
			this.search.county = ''
			return this.HttpService.get(
				`/autoapp-default-server-recovery/api/tbl-county/getTblCounty?city=${this.search.cshi}`
			).then(res => {
				if (res.statusCode === 200) {
					this.countyList = res.data
				}
			})
		},
		getTblSplbDalei() {
			return this.HttpService.get(
				'/autoapp-default-server-recovery/api/tbl-splb-dalei/getTblSplbDalei?flag=3'
			).then(res => {
				if (res.statusCode === 200) {
					this.dlList = res.data
				}
			})
		},
		// 获取小类
		getSpXiaolei(spid) {
			const url = `/autoapp-default-server-recovery/api/tblSplbYxypSubcategory/getBatchSubCategoryBySpid?isValid=1&spid=${spid}`
			return this.HttpService.get(url).then(res => {
				if (res.statusCode === 200) {
					this.xlList = res.data
				}
			})
		},
		// 大类改变
		dlChangeFun() {
			this.search.xlid = ''
			this.getSpXiaolei(this.search.spid)
		},
	},
	async mounted() {
		await this.getTblProvince()
		await this.getTblSplbDalei()
	},
}
</script>

<style scoped lang="scss">
.flex {
	display: flex;
	align-items: center;
	// margin: 0 20px;
	padding: 0 20px;

	span {
		min-width: 100px;
	}
}

.row-bg {
	margin-bottom: 15px;
}

.dialog {
	.dialog-footer {
		padding: 20px 60px;
	}
}

.tree {
	max-height: 200px;
	overflow: auto;
	border-radius: 3px;
	border: 1px solid #c0c4cc;
}
</style>



// WEBPACK FOOTER //
// src/views/recoveryManagement/areaManagement.vue